import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsChaseComponent } from './simple-icons-chase.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsChaseComponent ],
    exports:      [ SimpleIconsChaseComponent ],
    bootstrap:    []
})
export class SimpleIconsChaseModule {}
